module.exports = __webpack_public_path__ + "static/android-icon-192x192-5ae166a908ad1facc7964ff5745c3031.png";